// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "*+.popover[data-v-79922fb2]{visibility:hidden;z-index:3}*[data-v-79922fb2] :hover,* :hover+.popover[data-v-79922fb2]{visibility:visible}", ""]);
// Exports
module.exports = exports;
